import axios from 'axios'
import { partnerStore } from '../stores/partnerStore'
// import {kbStore} from '../stores/kbStore';
import globals from '../globals'
import { memberStore } from '../stores/memberStore'

async function setCompany(name, url) {
  const data = { name, url }
  let resourceUrl = globals.apiHostBot + '/set'
  try {
    let response = await axios.post(resourceUrl, data)
    return response.data
  } catch (e) {
    console.log('e! ', e)
    throw e
  }
}

async function getCompany() {
  let url = globals.apiHostBot + '/get'
  try {
    let response = await axios.get(url)
    return response.data
  } catch (e) {
    console.log('e! ', e)
    throw e
  }
}

const sleep = milliseconds => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

const IMAGE_MIME_TYPES = new Set([
  'image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/tiff', 'image/bmp',
])

const ACCEPTED_FILE_EXTENSIONS = '.png,.jpg,.jpeg,.gif,.webp,.tiff,.bmp,.pdf,.docx,.txt,.md,.pptx,.xlsx,.csv'

const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024

// Dedicated axios instance for the files service — must NOT include the
// X-Boomtown-Token / X-Boomtown-Date headers that are set as axios defaults.
const filesAxios = axios.create()

function getBotOrgId() {
  // partnerTeam is formatted as "ORG-TEAM" (e.g. "H3F-G4M") — only the org portion is needed
  const team = partnerStore.config?.partnerTeam || ''
  return team.split('-')[0] || team
}

function getFileUrl(fileId) {
  const orgId = getBotOrgId()
  return (
    globals.apiHostFiles +
    '/v1/files/' +
    encodeURIComponent(fileId) +
    '/download?orgId=' +
    encodeURIComponent(orgId)
  )
}

async function uploadFileForBot(file) {
  if (file.size > MAX_FILE_SIZE_BYTES) {
    throw new Error(`File "${file.name}" exceeds the 20MB limit.`)
  }

  const orgId = getBotOrgId()
  const formData = new FormData()
  formData.append('file', file)
  formData.append('orgId', orgId)
  formData.append('uploadedBy', memberStore.member.guestId || '')

  const url = globals.apiHostFiles + '/v1/files?orgId=' + encodeURIComponent(orgId)
  const response = await filesAxios.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })

  const result = response.data
  const attachmentType = IMAGE_MIME_TYPES.has(file.type) ? 'image' : 'file'
  return {
    type: attachmentType,
    file_id: result.id,
    filename: result.filename || result.name || file.name,
  }
}

async function sendChat(message, attachments = []) {
  const data = { 
    query: message,
    session_id: memberStore.member.guestId,
  }
  if (attachments.length > 0) {
    data.context = { attachments }
  }
  let url = globals.apiHostBot
  try {
    let response = await axios.post(url, data)

    return response.data
  } catch (e) {
    console.log('e! ', e)
    throw e
  }
}

async function sendChatStreaming(message, onContentUpdate, attachments = []) {
  const data = { 
    query: message,
    session_id: memberStore.member.guestId,
  }
  if (attachments.length > 0) {
    data.context = { attachments }
  }
  // Parse the apiHostBot URL to handle existing GET params
  const urlObj = new URL(globals.apiHostBot)
  // Add /stream to the pathname
  urlObj.pathname = urlObj.pathname + '/stream'
  const url = urlObj.toString()
  
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const reader = response.body?.getReader()
    const decoder = new TextDecoder()
    let content = ''
    let metadata = null
    let traceId = null
    let buffer = ''

    try {
      let finished = false
      while (!finished) {
        const { done, value } = await reader.read()
        if (done) {
          finished = true
          break
        }

        const chunk = decoder.decode(value, { stream: true })
        buffer += chunk

        // Process complete lines
        const lines = buffer.split('\n')
        buffer = lines.pop() || '' // Keep incomplete line

        for (const line of lines) {
          const trimmedLine = line.trim()
          if (!trimmedLine) continue

          try {
            let parsed
            if (trimmedLine.startsWith('data: ')) {
              // Server-Sent Events format
              const jsonData = trimmedLine.slice(6)
              if (jsonData.trim() === '[DONE]') break
              parsed = JSON.parse(jsonData)
            } else {
              // Direct JSON format
              parsed = JSON.parse(trimmedLine)
            }

            if (parsed.type === 'trace') {
              // Capture trace_id from the first trace message
              traceId = parsed.trace_id
              console.log('Captured trace_id:', traceId)
            } else if (parsed.type === 'content') {
              content += parsed.content || ''
              // Real-time callback for streaming
              if (onContentUpdate) {
                onContentUpdate(content, traceId)
              }
            } else if (parsed.type === 'metadata') {
              metadata = parsed
              console.log('Captured metadata:', metadata)
            } else if (parsed.type === 'done') {
              break
            }
          } catch (parseError) {
            console.warn('Failed to parse line:', trimmedLine, parseError)
          }
        }
      }
    } finally {
      reader.releaseLock()
    }

    // Return final structured response
    return {
      message: content || metadata?.complete_message || '',
      sources: metadata?.source || [],
      relatedLinks: metadata?.relatedLinks || [],
      triggers: metadata?.triggers || { escalateCase: false },
      showUserIdentification: metadata?.showUserIdentification || false,
      traceId: traceId,
    }
  } catch (e) {
    console.log('Streaming error: ', e)
    throw e
  }
}

async function setRole(role) {
  const data = { role }
  let url = globals.apiHostBot + '/updateRole'
  try {
    let response = await axios.post(url, data)
    return response.data
  } catch (e) {
    console.log('e! ', e)
    throw e
  }
}

async function getAgentConfig() {
  try {
    // Parse the botURL to extract org_id and agent_id
    const urlObj = new URL(globals.apiHostBot)
    const orgId = urlObj.searchParams.get('org_id')
    const agentId = urlObj.searchParams.get('agent_id')
    
    if (!orgId || !agentId) {
      console.warn('Missing org_id or agent_id in botURL')
      return null
    }
    
    // Construct the agent_config endpoint URL
    const baseUrl = `${urlObj.protocol}//${urlObj.host}`
    const configUrl = `${baseUrl}/agent_config?org_id=${orgId}&agent_id=${agentId}`
    
    const response = await axios.get(configUrl)
    return response.data
  } catch (e) {
    console.log('Error fetching agent config: ', e)
    throw e
  }
}

function getAnalyticsBaseUrl() {
  const urlObj = new URL(globals.apiHostBot)
  const baseUrl = `${urlObj.protocol}//${urlObj.host}`
  return baseUrl
}

async function submitBooleanRating(traceId, thumbsUp, userId) {
  console.log('submitBooleanRating called', { traceId, thumbsUp, userId })
  
  try {
    const analyticsUrl = getAnalyticsBaseUrl()
    const url = `${analyticsUrl}/api/analytics/scores/boolean`
    
    const data = {
      trace_id: traceId,
      name: thumbsUp ? 'thumbs_up' : 'thumbs_down',
      value: thumbsUp,
      user_id: userId
    }
    
    console.log('Submitting to:', url, 'with data:', data)
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data),
      mode: 'cors',
      credentials: 'omit'
    })
    
    console.log('Response status:', response.status)
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    const result = await response.json()
    console.log('Response data:', result)
    return result
  } catch (e) {
    console.log('Error submitting boolean rating: ', e)
    throw e
  }
}

async function submitCommentRating(traceId, comment, userId) {
  try {
    const analyticsUrl = getAnalyticsBaseUrl()
    const url = `${analyticsUrl}/api/analytics/scores/comment`
    
    const data = {
      trace_id: traceId,
      name: 'user_feedback',
      comment: comment,
      user_id: userId
    }
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data),
      mode: 'cors',
      credentials: 'omit'
    })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    return await response.json()
  } catch (e) {
    console.log('Error submitting comment rating: ', e)
    throw e
  }
}

export { 
  setCompany, 
  getCompany, 
  sendChat, 
  sendChatStreaming, 
  setRole, 
  getAgentConfig,
  submitBooleanRating,
  submitCommentRating,
  uploadFileForBot,
  getFileUrl,
  ACCEPTED_FILE_EXTENSIONS,
}
